"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _GlobalErrorHandler = _interopRequireDefault(require("./GlobalErrorHandler"));

var _GlobalComponentsContext = require("./GlobalComponentsContext");

var GlobalErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(GlobalErrorBoundary, _React$Component);

  function GlobalErrorBoundary(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  var _proto = GlobalErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.error(error);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({
        hasError: false,
        error: null
      });
    }
  } // eslint-disable-next-line handle-callback-err
  ;

  GlobalErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    if (this.state.hasError && this.state.error) {
      return /*#__PURE__*/_react.default.createElement(_GlobalComponentsContext.GlobalComponentsContext.Consumer, null, function (_ref) {
        var ErrorHandler = _ref.ErrorHandler;
        return /*#__PURE__*/_react.default.createElement(ErrorHandler, {
          error: _this2.state.error
        });
      });
    }

    return this.props.children;
  };

  return GlobalErrorBoundary;
}(_react.default.Component);

GlobalErrorBoundary.propTypes = {
  ErrorHandler: _propTypes.default.elementType,
  children: _propTypes.default.node,
  location: _propTypes.default.object
};
GlobalErrorBoundary.defaultProps = {
  ErrorHandler: _GlobalErrorHandler.default
};

var _default = (0, _reactRouterDom.withRouter)(GlobalErrorBoundary);

exports.default = _default;